import { ReadersSliderController } from './readers-slider.controller'

function readersSlider () {
  return {
    restrict: 'E',
    scope: true,
    templateUrl: '/posts/directives/readers-slider/readers-slider-directive.html?$$REVISION$$',
    controller: ReadersSliderController
  }
}

export { readersSlider }
